import React from 'react';
import styled from 'styled-components/macro';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.less';
export const DatePicker = props => {
  const dpRef = React.useRef();
  const { value, onChange, ...rest } = props;
  return (
    <DateInput
      ref={dpRef}
      onChange={onChange}
      selected={value}
      dateFormat="dd/MM/yyyy"
      {...rest}
      //
      // Ghetto way to close it since we dont want the out side click to fire,
      // because it will close any overlay the datepicker is placed inside.
      // 150ms is so the animation of selecting a date will finish before closing.
      //
      onSelect={() => {
        setTimeout(() => {
          if (dpRef.current) {
            dpRef.current.setOpen(false);
          }
        }, 150);
      }}
      shouldCloseOnSelect={false}
    />
  );
};

const DateInput = styled(ReactDatePicker)({
  width: '80%',
  border: '0.0625rem solid #BFBFBF',
  borderRadius: '0.125rem',
  height: '1.875rem',
  padding: '0 0.5rem',
  float: 'left'
});
